import { render, staticRenderFns } from "./EmailBody.vue?vue&type=template&id=7631fbd8&"
import script from "./EmailBody.vue?vue&type=script&lang=js&"
export * from "./EmailBody.vue?vue&type=script&lang=js&"
import style0 from "./EmailBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports